import React, { useContext } from 'react';
import { generatePath, useHistory, useParams } from 'react-router-dom';
import { ROUTE_PERSONS_ENTITY_PERSON_MEDICAL_INJURY_SCREENINGS } from 'routes/RouteList';
import Icon from 'components/icon/Icon';
import ConfirmMutationButton from './ConfirmMutationButton';
import messages from 'messages';
import { MUTATION_ARCHIVE_SCREENING } from 'services/aws/screenings-query';
import { QUERY_GET_PERSON_MEDICALS } from 'services/aws/injury-query';
import { StoreContext } from 'index';

const RemoveScreeningButton = ({ children, ...props }) => {
  const {
    authStore: {
      user: { rootEntityId }
    }
  } = useContext(StoreContext);
  const { entityId, groupId, personId, medicalId, injuryId, sessionId } =
    useParams();
  const { push } = useHistory();

  return (
    <ConfirmMutationButton
      {...props}
      mutation={MUTATION_ARCHIVE_SCREENING}
      confirmTitle={messages.modalConfirmRemoveScreeningTitle}
      confirmMessage={messages.modalConfirmRemoveScreeningMessage}
      variables={{
        personInjuryId: injuryId,
        testSessionId: sessionId
      }}
      refetchQueries={[
        {
          query: QUERY_GET_PERSON_MEDICALS,
          variables: { entityId: rootEntityId, personId }
        }
      ]}
      update={(cache, { data: { archiveScreening } }) => {
        if (archiveScreening) {
          push(
            generatePath(
              ROUTE_PERSONS_ENTITY_PERSON_MEDICAL_INJURY_SCREENINGS,
              {
                entityId,
                groupId,
                personId,
                medicalId,
                injuryId
              }
            )
          );
        }
      }}
    >
      <Icon id="delete" />
      {children}
    </ConfirmMutationButton>
  );
};

export default RemoveScreeningButton;
